import { QuestionType } from '../interfaces/questionType';

const formatQuestionTypeToClass = (questionType: QuestionType): string => {
  const splitted = questionType.toLowerCase().split('_');
  return splitted
    .map((word, index) => {
      if (index === 0) return word;
      return `${word[0].toUpperCase()}${word.slice(1)}`;
    })
    .join('');
};

export { formatQuestionTypeToClass };
